var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYellowFlame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.54615 0.907106C8.4425 0.845192 8.32402 0.8125 8.20329 0.8125C8.08256 0.8125 7.96408 0.845192 7.86043 0.907106C7.77494 0.974844 7.71725 1.07158 7.6983 1.179C7.67934 1.28641 7.70043 1.39705 7.75758 1.48996C9.86615 5.14139 10.3119 10.1128 7.43186 12.8557C6.32379 11.9245 5.44409 10.7516 4.86043 9.42711C3.7954 10.0186 2.91275 10.8906 2.30832 11.9483C1.70389 13.0061 1.40076 14.2092 1.43186 15.4271C1.47534 16.5007 1.73312 17.5548 2.19004 18.5273C2.64696 19.4998 3.29379 20.3711 4.09246 21.0899C4.89113 21.8087 5.82551 22.3605 6.84061 22.7128C7.85572 23.0651 8.93104 23.2109 10.0033 23.1414C15.5233 23.1414 18.3861 19.7128 18.5747 15.4271C18.7976 10.2842 15.1461 3.95853 8.54615 0.907106Z",
    fill: "#FFC073",
    stroke: "#000001",
    strokeWidth: 1.78571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2879 15.4258C14.2879 16.3351 13.9267 17.2072 13.2837 17.8501C12.6408 18.4931 11.7687 18.8544 10.8594 18.8544",
    fill: "#FFC073"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2879 15.4258C14.2879 16.3351 13.9267 17.2072 13.2837 17.8501C12.6408 18.4931 11.7687 18.8544 10.8594 18.8544",
    stroke: "#000001",
    strokeWidth: 1.78571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowFlame);
export default __webpack_public_path__ + "static/media/yellow-flame.133361a974689142c22ae2dd33089bf7.svg";
export { ForwardRef as ReactComponent };